import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-heatmap-series-options',
	templateUrl:'./AgHeatmapSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgHeatmapSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgHeatmapSeriesPluginCompPage
{
	mdContent_741 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgHeatmapSeriesOptions;
\`\`\``;
}
